import React from 'react';

import * as CACHE from './cache';
import * as COMPONENTS from './components';
import * as CARDS from './components/Cards';

export function renderPlaceholder(cachedProps, Type) {
    const {
        blockCount,
        cardType = 'CardType2',
        componentType = Type.displayName,
        hidden,
        placeholderType = 'Block',
        size = 'md',
    } = cachedProps || {};

    if (hidden || !cachedProps) {
        return (
            <div data-for-component={componentType} style={{height: '1px'}} />
        );
    }

    const LoadingComponent = COMPONENTS[placeholderType];

    if (!LoadingComponent) {
        throw new ReferenceError(
            `InvalidPlaceHolderTypeError: \`${placeholderType}\` does not exist for component <${componentType} />.`
        );
    }

    const props = {
        size,
        type: componentType,
    };

    if (placeholderType === 'HBlocks') {
        props.count = blockCount;
    } else if (placeholderType.includes('Carousel')) {
        props.Card = CARDS[cardType];

        if (!props.Card) {
            throw new ReferenceError(
                `InvalidPlaceHolderCardTypeError: \`${cardType}\` card does not exist for component <${componentType} />.`
            );
        }
    }

    return (
        <div className={'container--loading'}>
            <LoadingComponent {...props} />
        </div>
    );
}

export function placeholder(ref) {
    // If it's from `lazy: Function` component will be `ref`.
    // If it's from `withTripboardsLazy: Function` component will be `ref.props.children`.
    const component = ref.props.children ? ref.props.children : ref;

    return renderPlaceholder(CACHE.get(component), component.type);
}

export function placeholderFromType(Type) {
    return renderPlaceholder(CACHE.getByType(Type), Type);
}

export default placeholder;
